import { _js } from '@ifixit/localize';
import { StatusNotice } from 'Shared/status_notice';
import { FormManager } from 'Shared/form_manager';
import { releaseVersionEditor } from 'Shared/prosemirror/release_versions';
import { getSerializedText } from 'Shared/prosemirror/tiptap/editor_cache';

onDomReady(async () => {
   let formManager = null;
   const keymapping = {
      'Mod-Enter': () => {
         formManager && formManager.submit();
      },
   };
   const releaseEditor = await releaseVersionEditor(keymapping);

   when($('versionSelect'), addVersionSelectClickEvents);
   when($('releaseForm'), releaseForm => {
      formManager = new FormManager(releaseForm);

      const specificDate = _js('on a specific date');
      const numberOfDays = _js('after a number of days');
      const publishButton = $('publishButton');
      const releaseTitle = $('releaseTitle');
      const releaseVersion = $('releaseVersion');
      let versionTypeWarning = $('versionTypeWarning');
      const versionType = $('versionType');
      const versionTypeControl = $('versionTypeControl');
      let isSaving = false;
      const maxTitleLength = window.guide_constants.Release('MAX_TITLE_LENGTH');
      const releaseDateInput = $('releaseDateInput');
      const trainingPeriodValue = $('trainingPeriodValue');

      function getPublishMethod() {
         return $$('.dropdown-wrapper').get('data-value').at(-1);
      }

      function publishShouldBeDisabled() {
         const publishMethod = getPublishMethod();
         const missingPublishTypeData =
            (publishMethod === specificDate && releaseDateInput.value === '') ||
            (publishMethod === numberOfDays && trainingPeriodValue.value === '');

         const versionTypeIsMissing = versionType && !versionType.get('value');
         const releaseVersionValue =
            releaseVersion && releaseVersion.innerHTML && releaseVersion.innerHTML.trim();
         const releaseVersionIsMissing = releaseVersionValue === App.versionPendingDisplay;

         return versionTypeIsMissing || releaseVersionIsMissing || missingPublishTypeData;
      }

      function disablePublishButton() {
         publishButton.setAttribute('disabled', '');
         publishButton.removeClass('button-action');
      }

      function enablePublishButton() {
         publishButton.removeAttribute('disabled');
         publishButton.addClass('button-action');
      }

      function enablePublishIfValid() {
         if (publishShouldBeDisabled()) {
            disablePublishButton();
            return;
         }

         enablePublishButton();
      }

      function getApprovalTextWithDefault(defaultString, defaultStringOverride = null) {
         const publishMethod = getPublishMethod();
         if (defaultStringOverride && publishMethod !== _js('immediately')) {
            return defaultStringOverride;
         }

         return defaultString;
      }

      function updatePublishButtonText() {
         const defaultText = _js('Publish');
         const defaultTextOverride = _js('Schedule');
         const displayText = getApprovalTextWithDefault(defaultText, defaultTextOverride);
         const el = $('publishButton');

         el.set('text', displayText);
      }

      function updatePublishTypeLabel() {
         const defaultText = _js('Publish');
         const displayText = getApprovalTextWithDefault(defaultText);
         const el = $('publish-type-label');

         el.set('text', displayText);
      }

      function updateTrainingPeriodNotification(value) {
         const el = $('training-period-notification');

         if (value === _js('immediately')) {
            el.addClass('hidden');
         } else {
            const defaultText = _js('Users can train on this right away');
            const displayText = getApprovalTextWithDefault(defaultText);

            el.set('text', displayText);
            el.removeClass('hidden');
         }
      }

      if (versionType) {
         versionTypeControl.addEvent('click', ev => {
            let el = ev.target;
            let value = el.get('data-value');
            versionType.set('value', value);
            if (releaseVersion && !App.shouldSeedVersion) {
               releaseVersion.innerHTML = App.allowedVersions[value];
            }
            if (versionTypeWarning) {
               versionTypeWarning.destroy();
               versionTypeWarning = null;
            }

            enablePublishIfValid();

            const publishMethod = getPublishMethod();
            updateTrainingPeriodNotification(publishMethod);
            updatePublishTypeLabel();
            updatePublishButtonText();
         });
      }

      $$('.dropdown-wrapper').addEvent('valuechanged', function (ev) {
         let publishMethod = this.get('data-value');

         if (publishMethod === specificDate) {
            $('trainingPeriod').addClass('hidden');
            $('releaseDate').removeClass('hidden');
         } else if (publishMethod === numberOfDays) {
            $('trainingPeriod').removeClass('hidden');
            $('releaseDate').addClass('hidden');
         } else {
            $('trainingPeriod').addClass('hidden');
            $('releaseDate').addClass('hidden');
         }

         enablePublishIfValid();
         updateTrainingPeriodNotification(publishMethod);
         updatePublishButtonText();
      });

      trainingPeriodValue.addEvent('change', ev => {
         enablePublishIfValid();
      });

      trainingPeriodValue.addEvent('keyup', ev => {
         enablePublishIfValid();
      });

      trainingPeriodValue.addEvent('keydown', ev => {
         // Disallow '.', '-' and '+'
         if (ev.code === 190 || ev.code === 189 || (ev.code === 187 && ev.shift === true)) {
            ev.stop();
         }
      });

      releaseDateInput.addEvent('change', ev => {
         enablePublishIfValid();
      });

      formManager.required(releaseTitle);
      formManager.setValidator(releaseTitle, el => {
         if (releaseTitle.value.length > maxTitleLength) {
            /* Translators: %1 -> number; */
            formManager.error(
               el,
               _js(
                  'Release title length must be less than or equal to %1 characters.',
                  window.guide_constants.Release('MAX_TITLE_LENGTH')
               )
            );
         }
         isSaving = false;
         enablePublishIfValid();
      });
      publishButton.addEvent('click', ev => {
         ev.stop();

         if (publishShouldBeDisabled() || isSaving) {
            return;
         }

         isSaving = true;
         formManager.submit();
      });

      formManager.addSubmitHandler(() => {
         if (!App.releaseUrl) {
            alert('Not supported on this page!');
            return;
         }

         const notes = getSerializedText(releaseEditor);

         if (notes.length < App.minReleaseNotesLength) {
            $('releaseNotesError').removeClass('hidden');
            return;
         }

         const body = {
            title: releaseTitle.value,
            notes: notes,
         };

         if (App.guideid) {
            body.guideid = App.guideid;
         }

         if (App.revisionid && App.revisionid !== 'now') {
            body.revisionid = App.revisionid;
         }

         if (versionType) {
            body.type = versionType.value;
         }

         const publishMethod = getPublishMethod();

         if (releaseDateInput.value && publishMethod === specificDate) {
            // Convert time string to unix timestamp.
            body.release_date = Date.parse(releaseDateInput.value) / 1000;
         }

         if (trainingPeriodValue.value && publishMethod === numberOfDays) {
            body.training_period = Number.parseInt(trainingPeriodValue.value, 10);
         }

         if (App.hasPendingRelease) {
            if (
               !confirm(
                  _js(
                     'This Guide already has a pending Release. Do you want to close it to open a new Release?'
                  )
               )
            ) {
               isSaving = false;
               enablePublishIfValid();
               return;
            }
            body.force_pending_release_closure = true;
         }

         if (App.autoVersionsEnabled) {
            body.version = $('releaseVersion').innerHTML.trim();
         }

         new Request.API_2_0(App.releaseUrl, {
            method: 'post',
            statusPanelMessage: _js('Saving...'),
            onSuccess: function (response) {
               window.location = response.href;
            },
            onFailure: function (xhr, message) {
               const statusDiv = $('releaseVersionStatus');
               const notice = new StatusNotice();
               statusDiv.empty();
               statusDiv.adopt(notice.element);
               if (message === "'training_period' must be greater than zero") {
                  message = _js(
                     "Please add a value for 'number of days' that is greater than zero."
                  );
               }
               notice.error(message);

               statusDiv.scrollIntoView({ behavior: 'smooth' });

               isSaving = false;
               enablePublishIfValid();
            },
         }).send(body);
         disablePublishButton();
      });

      when($('seedVersionButton'), seedVersionButton => {
         seedVersionButton.addEvent('click', ev => {
            let releaseVersionSeed = $('seedVersionInput').value;

            if (/^(\d+)\.(\d+)$/.exec(releaseVersionSeed) === null) {
               let notice = new StatusNotice();
               $('releaseVersionStatus').adopt(notice.element);

               notice.error(
                  _js('Release Version must follow the format "{Major}.{Minor}". (ex: 2.1)')
               );
            } else {
               $('releaseVersion').innerHTML = releaseVersionSeed;
               enablePublishIfValid();
            }
         });
      });

      updatePublishTypeLabel();
   });
});

function confirmRevertGuide(a) {
   a.addEvent('click', ev => {
      if (!confirm(_js('Are you sure you want to replace the existing guide with this version?'))) {
         ev.stop();
      }
   });
}

function updateLocationTagGuideHistory(sel, guideid) {
   let revisionid = sel.get('value');
   window.location =
      window.guide_constants.GuideURI('TAG_GUIDE_HISTORY') + '/' + guideid + '/' + revisionid + '/';
}

function addVersionSelectClickEvents(sel) {
   let guideid = $('guideid').get('text');
   when($('revertGuide'), confirmRevertGuide);

   sel.addEvent('change', function (ev) {
      updateLocationTagGuideHistory(this, guideid);
   });

   $('versionPrev').addEvent('click', ev => {
      ev.stop();

      if (sel.selectedIndex < sel.length - 1) {
         sel.selectedIndex++;
         updateLocationTagGuideHistory(sel, guideid);
      }
   });

   $('versionNext').addEvent('click', ev => {
      ev.stop();

      if (sel.selectedIndex) {
         sel.selectedIndex--;
         updateLocationTagGuideHistory(sel, guide);
      }
   });
}
